
import "./SetQaPage.less"
import ThreeSet from "../myComponents/setThreeCom/setThreeCom.vue"
import QAComponent from "../myComponents/QAComponent/QAComponent.vue";
import { STORAGE_KEY } from "../utils/define";
import AddQa from "../myComponents/AddQa/AddQa.vue";
import HumanList from "../myComponents/HumanList/HumanList.vue";
import Badge from 'vux/src/components/badge/index.vue'

import {
getVuxUrlQuery,
createRequest,
makeBase64,
getUrlParams,
} from "../utils/utils";
import { utils } from "../S51WebGLSDK/utils/utils";
import { modelView,cardView } from '../api/api';
import FirmData from "../myComponents/Firm/FirmData.vue"
export default {
name: 'SetQaPage',
components: {
ThreeSet,
QAComponent,
AddQa,
HumanList,
Badge,
FirmData
},
props: {},
data() {
return {
preComponentsState:"",
componentsState: "",//页面 ''-主页 costume-问答库 qa-新建问答 set-设置
imageShow:"0",
addSaveRouter:1,
spareList: [],
modelViewId: 0,
spareTotal:0,
setSucceedState:false,
notYetSetQaState:false,
hasSetting:false,
hasQAList:false,
backmini:null,
cardType:'3d',
firmId:0,
}
},
computed: {},
watch: {

},
mounted() {
document.title= '设置智能对话'
console.log('%c⧭', 'color: #917399;font-size:100px', document.title)
console.log('%c⧭', 'color: #994d75;font-size:90px', this.modelViewId)
console.log('route history',this.$router)
this.getFigureList();
this.getFirmId()
},
destroyed()
{
},
created() {
let item = utils.getUrlParams(window.location.href);
this.backmini=item.backmini
this.imageShow = item.image_show;
this.cardType = item.type;
this.modelViewId = Number(item.id);
this.componentsState=item.startPage || 'set'
},
beforeRouteEnter(to, from, next) {
next(vm=>{          //  这里的vm指的就是vue实例，可以用来当做this使用
console.log('-----------before router enter')
console.log(to)
console.log(from)
})
},
methods: {
getFirmId()
{
if(this.cardType == '3d')
{

modelView(this.modelViewId).then((res) => {
this.firmId = res.data.image.company_id;
});

}
else if(this.cardType == '2d')
{

cardView(this.modelViewId).then((res) => {
this.firmId = res.data.card.company_id;
});
}
},
backShare(){
this.$wechat.miniProgram.navigateBack()

},
backPreview(){
this.notYetSetQaState=false
localStorage.setItem(STORAGE_KEY.MODEL_ID,this.modelViewId)







if(this.cardType == '2d'){
this.$router.push({path:'/TwoD',
query:{id:this.modelViewId,token:localStorage.getItem(STORAGE_KEY.TOKEN),image_show:this.imageShow,type:'2d'}});
}
else if(this.cardType == '3d'){
this.$router.push({path:'/ThreeD',
query:{id:this.modelViewId,token:localStorage.getItem(STORAGE_KEY.TOKEN),image_show:this.imageShow,type:'3d'}});
}
},

getFigureList() {
console.log("--------------------------set com getFigureList");
createRequest(
"get",
"applet/user/image/list",
{ page: 1, num: 100, status: 3 },
(res) => {
console.log("%c⧭", "color: #d90000", res.data);
if (res.code == 200) {
this.spareList = res.data.data;
this.spareTotal = res.data.total;

} else {
console.error(res.msg);
this.$vux.toast.show({
type: "text",
text: res.msg,
});
}
}
);
},
selectSpare(data) {
console.log("select spare", data);
this.modelViewId = data.id;
this.getFirmId()
},

getMovementTone() {
let spare = this.spareList.find((spare) => spare.id == this.modelViewId);
console.log("当前分身:", spare);
spare &&
config(spare.version).then((res) => {
this.toneList = res.data.audio_timbre_map[String(spare.gender)];
});
},


onInteractionSet(e)
{
this.componentsState = e;
},
onAQListChange(event){
console.log('qa list change',event)


},
onSpareInfoChange(e){
console.log('onSpareInfoChange',e)
if(e.clearSetting){
this.hasSetting=true
return
}
else  if(e.clearQA){
this.hasQAList = true
return
}
else{
if(this.cardType == '3d')
{
this.hasSetting = e.image.greet.length>0 && e.image.audio_timbre>0
this.hasQAList = e.qa_count>0
}
else if(this.cardType == '2d')
{
this.hasSetting = e.card.greet.length>0 && e.card.chat_audio_timbre>0
this.hasQAList = e.qa_count>0
}
}


},

onSaveSetRouter(e) {
if(e.modelViewId == this.modelViewId){
this.hasSet = e.greet && e.greet.length
}
if(this.cardType == '3d')
{

modelView(this.modelViewId).then((res) => {
if(res.data.qa_count==0){
this.notYetSetQaState=true
}
else{
this.setSucceedState=true
}
});

}
else if(this.cardType == '2d')
{

cardView(this.modelViewId).then((res) => {
if(res.data.qa_count==0){
this.notYetSetQaState=true
}
else{
this.setSucceedState=true
}
});
}


},

onAddQuestions(event) {
this.switchPage('qa')
console.log("%c⧭", "color: #ffa640", this.componentsState);
},

onAddSaveRouter(event) {
this.switchPage(event)
this.addSaveRouter = this.addSaveRouter + 1;
console.log("%c⧭", "color: #ffa640", this.componentsState);
},
switchPage(page){
this.preComponentsState = this.componentsState
this.componentsState = page;
console.log('switch page',page)
switch(page){
case '':
document.title=this.currentHumanName
break;
case 'costume':
case 'qa':
document.title='问答'
break;
case 'set':
document.title='设置'
break;

}
},
onBack(event){

console.log('----back',this.componentsState)
if(event=='preview'){
this.backPreview()
}
else if(this.componentsState=='qa'){ //当前是新建QA页面，返回QA列表
this.switchPage('costume')
}
else if(this.backmini){//返回微信
this.$wechat.miniProgram.navigateBack()
}
else
{
this.$router.back()
}

},

onCloseSetModel(e) {
this.switchPage("")
this.componentsState = ''



},

}
}



// WEBPACK FOOTER //
// ./src/components/SetQaPage.vue